import { FC } from "react";
import { Label } from "../../../Label/component";

interface CardFlagProps {
    flag?: string;
    external?: boolean;
    flagId?: string;
}

interface LabelPropType {
    flag?: string;
    external?: boolean;
    flagId?: string;
}

const CardFlag: FC<CardFlagProps> = ({ flag, external, flagId }) => {
    if (!flag) return null;

    const labelProps: LabelPropType = {
        flag,
        external,
        flagId,
    };
    return <Label {...labelProps} />;
};

export default CardFlag;
